import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-login-callback',
  imports: [
    TranslatePipe
  ],
  templateUrl: './login-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-callback.component.scss'
})
export class LoginCallbackComponent implements OnInit {

  private authService: AuthService = inject(AUTH_SERVICE);

  constructor(
    private router: Router
  ) {}

  async ngOnInit() {
    const error = await this.authService.handleLoginCallback();

    if (error) {
      console.error('Error during authentication:', error.message);
      this.router.navigate(['/login'], { 
        replaceUrl: true,
        queryParams: { error: error.message } 
      });
    } 
  }

}
